var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4791_974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FF8228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9662 23.0963C20.7262 23.0963 20.4862 23.0044 20.3024 22.8225C17.4674 19.9875 12.5287 19.9875 9.69555 22.8225C9.32992 23.1881 8.73555 23.1881 8.36992 22.8225C8.0043 22.4569 8.0043 21.8625 8.36992 21.4969C10.1418 19.7269 12.4949 18.75 14.9999 18.75C17.5049 18.75 19.858 19.7269 21.628 21.4969C21.9937 21.8625 21.9937 22.4569 21.628 22.8225C21.4462 23.0062 21.2062 23.0963 20.9662 23.0963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.125C10.4105 13.125 11.25 12.2855 11.25 11.25C11.25 10.2145 10.4105 9.375 9.375 9.375C8.33947 9.375 7.5 10.2145 7.5 11.25C7.5 12.2855 8.33947 13.125 9.375 13.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 13.125C21.6605 13.125 22.5 12.2855 22.5 11.25C22.5 10.2145 21.6605 9.375 20.625 9.375C19.5895 9.375 18.75 10.2145 18.75 11.25C18.75 12.2855 19.5895 13.125 20.625 13.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4791_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.fb776a8b4b0469ee5643626d8cc23801.svg";
export { ForwardRef as ReactComponent };